import dayjs from 'dayjs'
import isBetween from 'dayjs/plugin/isBetween'
import isSameOfAfter from 'dayjs/plugin/isSameOrAfter'
import { IKDTKlass } from 'stores/courses'

dayjs.extend(isBetween)
dayjs.extend(isSameOfAfter)

export const checkServerKdtApplyStatus = (kdtAttr: IKDTKlass) => {
  const {
    startedAt,
    endedAt,
    applyStartedAt,
    kdtAttr: { assignmentStartedAt, participationStartedAt },
  } = kdtAttr
  const isNewKdtFlag = kdtAttr.flags.some(v => v === 'new-kdt')
  const apiVersion = kdtAttr.apiVersion
  const curDate = dayjs()

  const isPreAlertPeriod = curDate.isBefore(applyStartedAt)
  const isApplyPeriod = curDate.isBetween(applyStartedAt, assignmentStartedAt as string)
  const isAssignmentPeriod = curDate.isBetween(assignmentStartedAt, participationStartedAt)
  const isParticipationPeriod = curDate.isBetween(participationStartedAt, startedAt)
  const isKDTPeriod = curDate.isBetween(startedAt, endedAt)

  let status: string = 'end'

  if (apiVersion === 'v3') {
    return 'assignment'
  } else if (isNewKdtFlag) {
    if (isPreAlertPeriod) {
      return (status = 'assignment')
    }

    if (isAssignmentPeriod) {
      return (status = 'assignment')
    }

    if (isAssignmentPeriod) {
      return (status = 'assignment')
    }

    if (isParticipationPeriod) {
      return (status = 'participation')
    }

    if (isKDTPeriod) {
      return (status = 'ing')
    }

    return status
  } else {
    if (isPreAlertPeriod) {
      return (status = 'apply')
    }

    if (isApplyPeriod) {
      return (status = 'apply')
    }

    if (isAssignmentPeriod) {
      return (status = 'assignment')
    }

    if (isParticipationPeriod) {
      return (status = 'participation')
    }

    if (isKDTPeriod) {
      return (status = 'ing')
    }

    return status
  }
}
